import { createContext, useContext } from "react";

export const RegisterContext = createContext({ openForm: () => {} });
export const useRegister = () => useContext(RegisterContext);
